import React, { useEffect, useRef, useState } from "react";
import { Link, useHistory } from "react-router-dom"; // Import de Link et useHistory
import { createPopper } from "@popperjs/core";
import { AuthService } from "services/auth.service";
import UserService from "services/user.service";

const UserDropdown = () => {
  const [dropdownPopoverShow, setDropdownPopoverShow] = useState(false);
  const [initials, setInitials] = useState("??"); // Valeur par défaut
  const history = useHistory();

  const btnDropdownRef = useRef();
  const popoverDropdownRef = useRef();

  const fetchAndSetInitials = async () => {
    try {
      const res = await UserService.getCurrentAccount();
      const { firstName, lastName } = res.data;
      const firstLetter = firstName ? firstName.charAt(0) : "";
      const lastLetter = lastName ? lastName.charAt(0) : "";
      setInitials((firstLetter + lastLetter).toUpperCase() || "U");
    } catch (error) {
      setInitials("U");
    }
  };

  useEffect(() => {
    // Chargement initial
    fetchAndSetInitials();

    // Écouter l'événement de mise à jour
    const handleUpdate = () => {
      fetchAndSetInitials();
    };

    window.addEventListener("userProfileUpdated", handleUpdate);

    // Nettoyage de l'écouteur
    return () => {
      window.removeEventListener("userProfileUpdated", handleUpdate);
    };
  }, []);

  const openDropdownPopover = () => {
    createPopper(btnDropdownRef.current, popoverDropdownRef.current, {
      placement: "bottom-end",
    });
    setDropdownPopoverShow(true);
  };

  const closeDropdownPopover = () => {
    setDropdownPopoverShow(false);
  };

  // Fermer le menu au clic à l'extérieur
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownPopoverShow &&
        btnDropdownRef.current &&
        !btnDropdownRef.current.contains(event.target) &&
        popoverDropdownRef.current &&
        !popoverDropdownRef.current.contains(event.target)
      ) {
        closeDropdownPopover();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [dropdownPopoverShow]);

  // Fonction de déconnexion propre
  const handleLogout = (e) => {
    e.preventDefault();
    AuthService.logout();
    history.push("/auth/login"); // Redirection après déconnexion
  };

  return (
    <>
      <a
        className="text-slate-500 block cursor-pointer"
        ref={btnDropdownRef}
        onClick={(e) => {
          e.preventDefault();
          dropdownPopoverShow ? closeDropdownPopover() : openDropdownPopover();
        }}
      >
        <div className="items-center flex">
          <span className="w-10 h-10 text-xs bg-[#D4AF37] text-[#0B1222] inline-flex items-center justify-center rounded-full border border-white/20 shadow-lg hover:scale-105 transition-transform duration-200">
            <span className="font-black uppercase tracking-tighter">
              {initials}
            </span>
          </span>
        </div>
      </a>

      <div
        ref={popoverDropdownRef}
        className={
          (dropdownPopoverShow ? "block " : "hidden ") +
          "bg-[#0B1222] text-base z-50 float-left py-2 list-none text-left rounded-xl shadow-2xl min-w-48 border border-white/10 mt-1"
        }
      >
        {/* LIEN VERS LE PROFIL */}
        <Link
          to="/admin/profile" // Assure-toi que cette route existe dans Admin.js
          className="text-[11px] uppercase font-black tracking-widest py-3 px-4 block w-full bg-transparent text-slate-300 hover:text-[#D4AF37] hover:bg-white/5 transition-colors"
          onClick={closeDropdownPopover}
        >
          <i className="fas fa-user-circle mr-3 text-[#D4AF37]"></i>
          Mon Profil
        </Link>

        <div className="h-0 my-2 border-t border-white/5" />

        {/* BOUTON DE DÉCONNEXION */}
        <button
          className="text-[11px] uppercase font-black tracking-widest py-3 px-4 block w-full text-left bg-transparent text-red-500 hover:bg-red-500/10 transition-colors"
          onClick={handleLogout}
        >
          <i className="fas fa-sign-out-alt mr-3"></i>
          Se déconnecter
        </button>
      </div>
    </>
  );
};

export default UserDropdown;
